export const MAX_FILE_SIZE_MB = 10;
export const ALLOWED_FILE_TYPES = ['text/xml', 'application/pdf'];
